export default {
    manage_createEditTemperature_EditTitle: "Editar Alerta de Temperatura de",
    manage_createEditTemperature_CreateTitle: "Agregar nueva Alerta de Temperatura",
    manage_createEditTemperature_success: "Alerta de Temperatura fue creada exitosamente",
    manage_createEditTemperature_success_edit: "Alerta de Temperatura fue actualizada exitosamente",
    manage_createEditTemperature_inmediate: "Inmediato",
    manage_createEditTemperature_hour: "Hora",
    manage_createEditTemperature_UnitInputLabel: "Unidad",
    manage_createEditTemperature_Enable: "Activa",
    manage_createEditTemperature_Disable: "Inactiva",
    manage_createEditTemperature_NameInputLabel: "Nombre",
    manage_createEditTemperature_minLengthMessage: "Mínimo de caracteres permitidos:",
    manage_createEditTemperature_maxLengthMessage: "Máximo de caracteres permitidos:",
    manage_createEditTemperature_minTempMessage: "La temperatura debe ser mayor o igual a",
    manage_createEditTemperature_maxTempMessage: "La temperatura debe ser menor o igual a",
    manage_createEditTemperature_HighInputLabel: "Temperatura Máxima (°F)",
    manage_createEditTemperature_LowInputLabel: "Temperatura Mínima (°F)",
    manage_createEditTemperature_TriggerInputLabel: "Modo de disparo",
    manage_createEditTemperature_AlertInputLabel: "Modo de alerta",
    manage_createEditTemperature_ContactsInputLabel: "Contactos",
    manage_createEditTemperature_once: "Una vez",
    manage_createEditTemperature_recurring: "Periódica",
    manage_createEditTemperature_error_fillAllEnabledZones: "Por favor completa todos los campos requeridos de las Zonas Activas"
}